import { useMutation } from "@tanstack/react-query";
import { createStudyApi } from "@/API/createStudyApi";
import { StudyCreatePayload, StudyDataType } from "@/types/apiTypes";
import { useInvalidateQueries } from "@/hooks/helperHooks/useInvalidateQueries";
import { ShowNotification } from "@/components/ShowNotification";
import { useErrorBoundary } from "@/hooks/helperHooks/useErrorBoundary";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useCreateStudy = () => {
  const { startLoading, stopLoading } = useLoadingContext();
  const { invalidateStudies } = useInvalidateQueries();
  const handleError = useErrorBoundary();

  return useMutation<StudyDataType, Error, StudyCreatePayload>({
    mutationFn: async (studyData) => {
      startLoading();
      try {
        return await createStudyApi(studyData);
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    onSuccess: () => {
      invalidateStudies();
      ShowNotification({
        title: "Study Created",
        message: "A new study has been created successfully.",
        color: "success",
      });
    },
    onError: (error: Error) => {
      ShowNotification({
        title: "Error",
        message: "Failed to create the study.",
        color: "error",
      });
      handleError(error);
    },
  });
};
